// extracted by mini-css-extract-plugin
module.exports = {"header":"DirectToAppInfoForm_header___FK_0","tooltipPopperBoxStyles":"DirectToAppInfoForm_tooltipPopperBoxStyles__r_w7b"};